import styled from '@emotion/styled';
import { ContainerDiv } from '@vromo/ui/components/Container';

export const SegmentRow = styled.div`
    display: flex;
    flex-direction: row;

    @media (max-width: 1000px) {
        flex-direction: column;
    }
`;

export const Segment = styled(ContainerDiv)`
    padding: 20px;
    flex: 1;

    @media (max-width: 1000px) {
        flex: unset;
    }
`;

export const SegmentTitle = styled.div`
    margin-left: 10px;
`;

export const RatesWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 50px;

    @media (max-width: 800px) {
        flex-direction: column;
    }
`;

export const RateInput = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    margin: 0px 20px;

    @media (max-width: 800px) {
        margin-bottom: 10px;
    }
`;

export const HeaderRight = styled.th`
    text-align: right !important;
`;

export const CellRight = styled.td`
    text-align: right;
`;

export const CellCenter = styled.td`
    text-align: center;
`;
